import { render, staticRenderFns } from "./FeedbackChatPanel.vue?vue&type=template&id=750b82e4&scoped=true"
import script from "./FeedbackChatPanel.vue?vue&type=script&lang=js"
export * from "./FeedbackChatPanel.vue?vue&type=script&lang=js"
import style0 from "./FeedbackChatPanel.vue?vue&type=style&index=0&id=750b82e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b82e4",
  null
  
)

export default component.exports